import { createSlice } from "@reduxjs/toolkit";

const initialClearingAccountReportState = {
  listLoading: false,
  actionsLoading: false,
  chartLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  chartEntities: null,
  xlsFilename: null
};
export const callTypes = {
  list: "list",
  action: "action",
  chart: "chart"
};

export const clearingAccountReportSlice = createSlice({
  name: "clearingAccountReport",
  initialState: initialClearingAccountReportState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.chart) {
        state.chartLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else if (action.payload.callType === callTypes.chart) {
        state.chartLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    clearingAccountReportListFetched: (state, action) => {
      const { totalCount, entities, error } = action.payload;
      state.listLoading = false;
      state.error = error || null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    clearingAccountReportListExport: (state, action) => {
      const { xlsFilename } = action.payload;
      state.actionsLoading = false;
      state.xlsFilename = xlsFilename;
    },

    clearingAccountChartDetailsFetched: (state, action) => {
      const { chartEntities, error } = action.payload;
      state.chartLoading = false;
      state.error = error || null;
      state.chartEntities = chartEntities;
    }
  }
});
